module.exports = __webpack_public_path__ + "static/media/return.211bf83a.png";